import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Col, Row, Typography, Button } from 'antd';
import Logger from '../../../../../lib/Logger';

import LearningModuleStepsHeader from './LearningModuleStepsHeader';
import LearningModuleStepsList from './LearningModuleStepsList';
import ComponentMedia from '../containers/ComponentMediaContainer';
import ReactQuill from 'react-quill';
import { withRouter } from 'react-router';
import { pathTo } from '../../../Routes';

const { Title } = Typography;

const modules = {
  toolbar: '#toolbar-read-only-module',
};

const LearningModuleStepsScreen = ({
  activeId,
  moduleId,
  learningModule,
  load,
  loadSteps,
  totalModuleLearningSteps,
  list,
  moduleStepIdActive,
  createModuleView,
  history,
  patch,
  ...props
}) => {
  const goToModule = (id) => {
    history.push(
      pathTo('LearningModuleStepsScreen', {
        id: activeId,
        moduleId: id,
      })
    );
  };

  useEffect(() => {
    load(activeId, moduleId);
  }, [activeId, moduleId, load]);

  useEffect(() => {
    if (learningModule?.id && activeId) {
      loadSteps(activeId, moduleId);
      createModuleView(moduleId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeId, learningModule?.id, loadSteps]);

  return (
    <Translation>
      {(t) => (
        <div className='learning-module-learning-steps-screen'>
          <LearningModuleStepsHeader
            activeId={activeId}
            moduleId={moduleId}
            title={learningModule?.module_serie?.title}
            titleMain={learningModule?.title}
            state={learningModule?.state_current}
            patch={patch}
          />
          <Row gutter={80}>
            <Col
              lg={{ span: 12, order: 1 }}
              md={{ span: 24, order: 1 }}
              sm={{ span: 24, order: 1 }}
              xs={{ span: 24, order: 1 }}
              style={{ marginBottom: '40px' }}
            >
              <div>
                {learningModule && <ComponentMedia data={learningModule} />}

                {totalModuleLearningSteps > 0 && (
                  <>
                    {learningModule && learningModule?.content && (
                      <div className='learning-module-content'>
                        <div id='toolbar-read-only-module'></div>
                        <ReactQuill
                          modules={modules}
                          readOnly
                          value={learningModule?.content}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </Col>
            <Col
              lg={{ span: 12, order: 2 }}
              md={{ span: 24, order: 2 }}
              sm={{ span: 24, order: 2 }}
              xs={{ span: 24, order: 2 }}
            >
              {totalModuleLearningSteps > 0 ? (
                <LearningModuleStepsList
                  stepsComplete={learningModule?.steps_completed}
                  percentage={learningModule?.percentage}
                  moduleId={moduleId}
                  activeId={activeId}
                  list={list}
                  total={totalModuleLearningSteps}
                  moduleStepIdActive={moduleStepIdActive}
                />
              ) : (
                <>
                  <Title level={4} style={{ marginBottom: '20px' }}>
                    {learningModule?.title}
                  </Title>

                  {learningModule?.content && (
                    <div className='learning-module-content'>
                      <div id='toolbar-read-only-module'></div>
                      <ReactQuill
                        modules={modules}
                        readOnly
                        value={learningModule?.content}
                      />
                    </div>
                  )}
                </>
              )}

              <div style={{ marginTop: '30px' }}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Button
                      disabled={!learningModule?.previous_module}
                      size='large'
                      block
                      type='default'
                      onClick={() =>
                        goToModule(learningModule?.previous_module)
                      }
                    >
                      {t('learning_module_button_previous')}
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      disabled={!learningModule?.next_module}
                      size='large'
                      block
                      type='primary'
                      onClick={() => goToModule(learningModule?.next_module)}
                    >
                      {t('learning_module_button_next')}
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </Translation>
  );
};

export default withRouter(LearningModuleStepsScreen);

Logger.log('silly', `LearningModuleStepsScreen loaded.`);
